<template>
  <div class="mine-contents">
    <div class="mine-list">
      <template v-for="group in reportList" >
        <template v-for="(report, i) in group.list">
          <div v-if="report.type === 'mashup'" :key="`${group.month}-${i}-mashup`" class="mine-report-mashup"
          >
            <div class="mine-mashup-header">
              <div class="mashup-title-wrap">
                <i class="icon icon--mashup size-20"></i>
                <div class="title">Mashup <span v-if="report.version > 1">v. {{ report.version }}</span></div>
              </div>
              <div class="label-list">
                <div v-if="report.lang" class="lang">
                  <i class="icon icon--flag" :class="report.lang"></i>
                  <span class="lang-text">{{report.lang}}</span>
                </div>
                <div v-if="report.new" class="state-label new">NEW</div>
              </div>
              <div class="date-view-info">
                <div class="date-info">{{ setRegDate(report.regDate) }}</div>
                <div class="separator"></div>
                <div class="view-count-info">
                  <i class="icon icon--eye-white"></i>
                  <span>{{ report.viewCount }}</span>
                </div>
              </div>
              <span class="ai-report-mark" :class="report.reportStatus" @click="onShowReport(report.id, report.reportStatus)">
                    <i class="icon icon--ba-arrow size-20"></i>
                <!-- <i class="icon" :class="`${report.reportStatus === 'ing' ? 'icon--ai-report-mark-gray' : 'icon--ai-report-mark-mashup'}`"></i> -->
                </span>
            </div>
            <div v-for="(mashup, i) in mashupMinCount" class="mine-report-item report mashup"
                 :class="[{error: report.isError}]"
                 :key="`mashup-${mashup}`">
              <template v-if="report.refList[i]">
                <MineListCardItem
                  :timezone="domain.timezoneName"
                  :mine-data="report.refList[i]"
                  :report-type="report.type"
                  :is-error="report.isError"
                  :isReportError="report.isReportError"
                  :is-analysis="report.reportStatus === 'ing'"
                  :report-status="report.reportStatus"
                  :keyword="keyword"
                  @popup="setPopup" @compare="compare"
                />
                <div class="filing-iron">
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="190" viewBox="0 0 52 190" fill="none">
                    <defs>
                      <g id="filing">
                        <circle cx="5" cy="5" r="5" fill="#333" />
                        <circle cx="47" cy="5" r="5" fill="#333" />
                        <path d="M 5 5 L 47 5" stroke="#B7B7B7" stroke-width="5" stroke-linecap="round" />
                        <path d="M 5 5 L 47 5" stroke="#B7B7B7" stroke-width="5" stroke-opacity="0.3" stroke-linecap="round" transform="translate(0, 3)" />
                      </g>
                    </defs>
                    <use xlink:href="#filing" />
                    <use xlink:href="#filing" transform="translate(0, 90)"/>
                    <use xlink:href="#filing" transform="translate(0, 180)"/>
                  </svg>
                </div>
              </template>
              <template v-else >
                <div class="no-report-contents">
                  <i class="icon icon--report-empty"></i>
                  <div class="title">
                    {{ $t('mine.sideTab.mashup.notSelectLast') }}
                  </div>
                </div>
              </template>
            </div>
            <template v-if="report.isError || report.isReportError">
              <div class="error-label-wrapper">
                <!-- No data, Retry unavailable -->
                <div v-if="report.isError" class="error-label">
                  <i class="icon icon--bell-till" v-btf-tooltip:top.start="{ contents: $t('mine.report.errorNoData.errorDesc'), offset: -12 }"></i>
                  <span>{{ $t('mine.report.errorNoData.errorTag')}}</span>
                </div>
                <!-- Data exists, Retry available -->
                <div v-else-if="isReportError" class="error-label">
                  <i class="icon icon--bell-till" v-btf-tooltip:top.start="{ contents: $t('mine.report.errorFail.errorDesc'), trigger: 'click', offset: -12 }"></i>
                  <span>{{ $t('mine.report.errorFail.errorTag')}}</span>
                </div>
              </div>
              <!-- Data exists, Retry available -->
              <div v-if="!report.isError && report.isReportError" class="retry-button btf-button primary icon" @click="retry(report)">
                <i class="icon icon--refresh-white"></i>
                {{  $t('common.retry') }}
              </div>
            </template>
          </div>
          <div v-else :key="`${group.month}-${i}`" class="mine-report-item report"
               :class="[{comparing: report.isComparing}, {dashboard: (report.type === 'dashboard' || report.type === 'dashboardHell') && report.reportStatus !== 'ing'}, { ing: report.reportStatus === 'ing'}, {error: report.isError}]"
          >
            <div v-if="report.lang && report.type !== 'cxTrends'" class="lang" :class="{'error': report.isError}">
              <i class="icon icon--flag" :class="report.lang"></i>
              <span class="lang-text">{{report.lang}}</span>
            </div>
            <div class="clip-on-card" v-if="showHellClip(report)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="49" viewBox="0 0 20 49" fill="none">
                <path opacity="0.12" d="M5.5 26C5.5 25.1716 4.82843 24.5 4 24.5C3.17157 24.5 2.5 25.1716 2.5 26H5.5ZM19.5 15.5V14H16.5V15.5H19.5ZM5.5 40.5V26H2.5V40.5H5.5ZM16.5 15.5V40.5H19.5V15.5H16.5ZM11 46C7.96243 46 5.5 43.5376 5.5 40.5H2.5C2.5 45.1944 6.30558 49 11 49V46ZM11 49C15.6944 49 19.5 45.1944 19.5 40.5H16.5C16.5 43.5376 14.0376 46 11 46V49Z" fill="black"/>
                <path d="M4.5 12.5V14H7.5V12.5H4.5ZM3.5 24C3.5 23.1716 2.82843 22.5 2 22.5C1.17157 22.5 0.5 23.1716 0.5 24H3.5ZM14.5 6.5V38.5H17.5V6.5H14.5ZM7.5 12.5V6.5H4.5V12.5H7.5ZM3.5 38.5V24H0.5V38.5H3.5ZM9 44C5.96243 44 3.5 41.5376 3.5 38.5H0.5C0.5 43.1944 4.30558 47 9 47V44ZM14.5 38.5C14.5 41.5376 12.0376 44 9 44V47C13.6944 47 17.5 43.1944 17.5 38.5H14.5ZM11 3C12.933 3 14.5 4.567 14.5 6.5H17.5C17.5 2.91015 14.5899 0 11 0V3ZM11 0C7.41015 0 4.5 2.91015 4.5 6.5H7.5C7.5 4.567 9.067 3 11 3V0Z" fill="#EC0047"/>
                <path d="M12.5 7.5C12.5 6.67157 11.8284 6 11 6C10.1716 6 9.5 6.67157 9.5 7.5H12.5ZM9.5 12.5V14H12.5V12.5H9.5ZM9.5 7.5V12.5H12.5V7.5H9.5Z" fill="#EC0047"/>
              </svg>
            </div>
            <div class="outline-box" :class="{'is-hover' : isHover}" v-if="report.type === 'dashboard' || report.type === 'dashboardHell' || report.type === 'cxTrends'&& !report.isError && report.reportStatus !== 'ing'" >
              <button class="corner-button goto" @click="onShowReport">
                <i class="icon icon--ba-arrow size-20"></i>
              </button>
            </div>
            <MineListCardItem
              :mine-data="report"
              :timezone="domain.timezoneName"
              :report-type="report.type"
              :is-error="report.isError"
              :isReportError="report.isReportError"
              :is-analysis="report.reportStatus === 'ing'"
              :report-status="report.reportStatus"
              :comparingState="report.isComparing"
              :keyword="keyword"
              @popup="setPopup" @compare="compare"
              @retry="retry"
              @onCompare="onCompare"
              @changeTitleEditMode="changeTitleEditMode"
              @onTitleHover="onTitleHover"
            />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import MineListCardItem from '@/components/mine/MineListCardItem.vue'

import { mapState } from 'vuex'
import { format, parse } from 'date-fns'
import { REPORT_LINK } from '@/libs/constants'
import { isInIframe } from '@/libs/auth-helper'

export default {
  name: 'MineListCardView',
  components: { MineListCardItem },
  props: {
    reportList: {
      type: Array,
      required: true
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mashupMinCount: 2,
      isHover: false
    }
  },
  computed: {
    ...mapState([
      'domain'
    ])
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onTitleHover (isHover) {
      this.isHover = isHover
    },
    showHellClip (report) {
      return !report.isReportError && report.reportStatus !== 'ing' && !report.isComparing && (report.type === 'dashboardHell' || report.type === 'cxTrends')
    },
    retry (report) {
      this.$emit('retry', report)
    },
    setPopup (data) {
      this.$emit('setPopup', data)
    },
    compare (data) {
      this.$emit('compare', data)
    },
    onCompare (report, value) {
      this.$emit('onCompare', report, value)
    },
    onShowReport (reportId, status) {
      if (status === 'ing') {
        return null
      } else {
        window.open(REPORT_LINK + '/' + reportId, isInIframe() ? '_self' : '_blank')
        this.isReportClicking = false
      }
    },
    setRegDate (utcDate) {
      const date = parse(utcDate, this.timezone)
      return format(date, 'YYYY-MM-DD HH:mm:ss')
    },
    changeTitleEditMode (reportId, value) {
      this.onTitleHover(true)
      const report = this.reportList
        .flatMap(group => group.list)
        .find(r => r.id === reportId)
      if (report) {
        this.$set(report, 'isTitleEditMode', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$analyzeColor: #B65EFC;

.mine-contents {
    & * {
        box-sizing: border-box;
    }
    .mine-list-date {
        position: relative;
        top: 0;
        padding: 10px 0;
        color: #888;
        font-size: 14px;
        font-weight: 500;
        span.date {
            background-color: #F4F4F1;
            padding-right: 10px;
        }
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            border-top: 1px solid #c1c1c1;
            z-index: -1;
        }
    }
    .mine-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 70px 24px;
    padding: 60px 44px 70px;
  }
}

.mine-report-item {
    flex-shrink: 0;
    position: relative;

  .outline-box {
    cursor: pointer;
    position: absolute;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.06),
      0 18px 22px -7px rgba(0, 0, 0, 0.16);
    transition: box-shadow 0.2s ease-in-out;
    pointer-events: none;

    &.is-hover {
      .corner-button {
        opacity: 0;
      }
    }

    .corner-button {
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;
      opacity: 0;
      width: 67px;
      height: 67px;
      border: none;
      padding: 0;
      background-color: #0074ff;
      position: absolute;
      top: -1px;
      right: -1px;
      border-top-right-radius: 10px;
      clip-path: polygon(0 0, 100% 0, 100% 100%);
    }

    .icon {
      display: block;
      transition: all 360ms cubic-bezier(0.68, 0, 0.47, 1);
      position: absolute;
      top: 6px;
      margin: 6px;
      right: 16px;
    }
  }

  &:hover {
    .outline-box {
      z-index: 4;
      border-radius: 10px;
      box-shadow:
        0 0 0 4px #0074ff,
        0 18px 22px -7px rgba(0, 0, 0, 0.16);

      &:not(.is-hover) {
        .corner-button {
          opacity: 1;
        }
      }

      .icon {
        transform: translateX(10px);
      }
    }
  }

    &:not(.comparing):after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 1px;
    box-sizing: content-box;
    top: -1px;
    left: -1px;
    border-radius: 11px;
    z-index: -1;
    }
    &.report {
    width: 320px;
    height: 494px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 18px 22px -7px rgba(0, 0, 0, 0.16);

    &:hover:after {
        box-shadow: inherit;
    }

      &.dashboard {
        &:hover {
          box-shadow: none;
          &:after {
            box-shadow: none;
            z-index: -1;
          }
        }
      }

    &.error {
        &.mashup {
        margin-top: 43px;
        height: 451px;
        }
    }

    & .lang {
        position: absolute;
        top: -11px;
        left: 20px;
        display: flex;
        width: 44px;
        height: 20px;
        padding: 4px 2px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        flex-shrink: 0;
        border-radius: 4px;
        outline: 1px solid rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        background: #FFF;
        z-index: 9;

        & .lang-text {
        text-transform: uppercase;
        color: #666;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%; /* 12px */
        }

        &.error {
        & .icon,
        & .lang-text {
            opacity: 0.3;
        }
        }
    }
    }
    &.comparing {
    cursor: initial !important;
    }
    .filing-iron {
    position: absolute;
    top: 50%;
    left: calc(100% - 14px);
    z-index: 1;
    transform: translateY(-50%);

    }
    &:last-child, &.error {
    .filing-iron {
        display: none;
    }
    }
    .no-report-contents {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate( -50%, -50%);
    text-align: center;
    color: #767676;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    max-width: 130px;
    word-wrap: break-word;
    }
  .clip-on-card {
    position: absolute;
    width: 18px;
    height: 47px;
    top: -12px;
    right: 44px;
    z-index: 10;
    transition: transform .5s;
    transform-origin: 50% 50%;
    &.click {
      transform: rotate(45deg);
      svg {
        path:first-child {
          d: path('M 1 23 L 1 38 A 7 7 0 0 0 15 38 L 15 -1');
        }
        path:last-child {
          d: path('M 10 7 L 10 1');
        }
      }
    }
  }
}
.mine-report-mashup {
    position: relative;
    display: flex;
    gap: 24px;
    &:after {
    content: '';
    position: absolute;
    top: -11px;
    left: -11px;
    width: 100%;
    height: 100%;
    padding: 7px;
    box-sizing: content-box;
    border: 4px solid #333;
    border-radius: 18px;
    z-index: -1;
    }
    .mine-mashup-header {
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 9px 9px 0 0;
    bottom: calc(100% + 7px);
    left: 15px;

    & .mashup-title-wrap {
        .title {
        font-size: 20px;
        font-weight: 600;
        }
    }
    & .label-list {
        display: flex;
        gap: 16px;
        :not(:last-child) {
        &:after {
            position: absolute;
            top: 50%;
            right: -9px;
            content: '';
            width: 1px;
            height: 8px;
            background: #FFF;
            transform: translateY(-50%);
            opacity: 0.2;
        }
        }
    }
    & .lang {
        position: relative;
        display: flex;
        width: 44px;
        height: 20px;
        padding: 4px 2px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        background: #FFF;
        z-index: 9;

        & .lang-text {
        text-transform: uppercase;
        color: #666;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%;
        display: inline-block;
        }
    }

    & .separator {
        display: inline-block;
        width: 1px;
        height: 8px;
        opacity: 0.2;
        margin: 0 4px;
        background-color: #fff;
    }

    & > div {
        display: flex;
        align-items: center;
        gap: 4px;
        &:first-child {
        padding-left: 8px;
        }
    }
    .state-label {
        position: relative;
        display: inline-block;
        color: #FFF;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;

        padding: 4px 6px;
        vertical-align: baseline;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.80);
        &.new {
        display: inline-block;
        background: linear-gradient(180deg, #FFAE00 0%, #FF9800 100%);
        }
        &.analyze {
        color: $analyzeColor;
        border-color: rgba(0, 0, 0, 0.12);
        background-color: #fff;;
        }
    }
    .date-view-info {
        padding: 4px 26px 4px 4px;
        color: #BBB;
        font-size: 12px;
        font-weight: 500;
        line-height: 1;
        border-right: 1px solid #ffffff4d;
        .view-count-info {
          display: flex;
          align-items: center;
          gap: 4px;
        }
    }

    span.ai-report-mark {
        cursor: pointer;
        width: 32px;
        height: 32px;
        padding: 6px;
        margin-left: -4px;
        text-align: center;
        box-sizing: border-box;
        &.ing, &.error {
        pointer-events: none;
        opacity: .3;
        }
    }
    &:before, &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 10px;
        height: 10px;
        border: 4px solid #333;
        border-top-width: 0
    }
    &:before {
        right: calc(100% - 4px);
        border-bottom-right-radius: 10px;
        border-left-width: 0
    }
    &:after {
        left: calc(100% - 4px);
        border-bottom-left-radius: 10px;
        border-right-width: 0

    }
    }
    .error-label-wrapper {
    position: absolute;
    top: 4px;
    width: 100%;
    .error-label {
        width: 100%;
        padding: 4px 5px;
        display: flex;
        align-items: center;
        gap: 5px;
        background-color: #F4E43A;
        border-radius: 5px;
        font-size: 12px;
        color: #444;
        i.icon {
        background-color: #fff;
        border-radius: 50%;
        }
    }
    }
    .retry-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    }
}
</style>
